import { Locale } from "@src/context/attributeConfig/AttributeConfigContext";

export const validateIsoLanguage = (iso: string, supportedLanguages: string[]) => {
    return supportedLanguages?.includes(iso) ? iso : Locale.EN;
};

export const loadMessagesForLanguages = async (iso: string, url: string, projects: string[], supportedLanguages: string[]) => {
    const validatedIso = validateIsoLanguage(iso, supportedLanguages);

    const urls = projects?.map((project) => {
        return `${url}/${project}/${validatedIso}.json`;
    });

    const data = await Promise.all(
        urls?.map((url) =>
            fetch(url)
                .then((r) => {
                    return r.json();
                })
                .then((data) => {
                    return { data, error: null, url };
                })
                .catch((error) => {
                    return { data: null, error, url };
                }),
        ),
    );

    return mergeObjects(
        data.map((item) => {
            return item.data;
        }),
    );
};

export const mergeObjects = (data: Array<Record<string, string>>) => {
    return data.reduce((accumulator, data) => {
        if (data) {
            return { ...accumulator, ...data };
        } else {
            // do not handle error case - logged automatically in console
        }

        return { ...accumulator };
    }, {});
};
